import React from 'react';
import {LanguageToggle} from 'components/LanguageToggle';
import './style.css';


const Container = () => {
    return (
        <div className="light-navbar">
            <div className="left">
                <a className="logo" href="/o">
                </a>
            </div>

            <div className="right language-toggle">
                <LanguageToggle/>
            </div>
        </div>
    );
};

export default Container;
